import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import IconButtonLinkUI from '../../../widgets/action/IconButtonLinkUI'
import OrderItemRightUI from '../order/OrderItemRightUI'
import OrderItemLeftUI from '../order/OrderItemLeftUI'

const BudgetItemList = ({context, messageList, itemList,
    searchFilter, onRefreshClick, onSearchFilterChange
  }) =>
  <div className='bdg_budget g_m_top_100'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        itemList.map((item, i) =>
          <ItemRowUI key={i} context={context} messageList={messageList} item={item} />
        )
      }
    </LRTableBodyUI>
  </div>

const ItemRowUI = ({context, item, messageList}) =>
  <LRTableRowUI
    context={context}
    left={<OrderItemLeftUI context={context} messageList={messageList} item={item} />}
    right={<OrderItemRightUI context={context} messageList={messageList} item={item} />}
  />

const ActionLeftUI = ({context, messageList, onRefreshClick}) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {
      context.permissions && context.permissions.includes('acc_manage') &&
      <IconButtonLinkUI messageList={messageList} icon='icon-plus' to='/budgets/create' labelKey='c_add_bdg_item' />
    }
  </div>

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange
  }) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default BudgetItemList
